<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main">
        <breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    Header as AppHeader,
    Sidebar,
    Footer as AppFooter,
    Breadcrumb,
} from '../components/admin';

export default {
    name: 'full',
    components: {
        AppHeader,
        Sidebar,
        AppFooter,
        Breadcrumb,
    },
    data()
    {
        return {
            nav: [],
        };
    },
    created()
    {
        if (this.langInitialized)
        {
            this.initMenu();
        }
    },
    methods: {
        initMenu()
        {
            const me = this;

            this.nav = [
                {
                    name: me.$i18n.t('DASHBOARD'),
                    url: '/admin/dashboard',
                    visible: !!(me.globals.acl.Child && me.globals.acl.Child.instantiate),
                    icon: 'home',
                },
                {
                    name: me.$i18n.t('DASHBOARD'),
                    url: '/admin/dashboardkindergarten',
                    visible: !!(me.globals.acl.ChildKindergarten && me.globals.acl.ChildKindergarten.instantiate),
                    icon: 'home',
                },
                {
                    name: me.$i18n.t('CHILDREN'),
                    icon: 'users',
                    visible: !!(me.globals.acl.Child && me.globals.acl.Child.insertAction),
                    children: [
                        {
                            name: me.$i18n.t('CHILD'),
                            url: '/admin/children/child',
                            visible:
                !!(me.globals.acl.Child && me.globals.acl.Child.insertAction),
                            icon: 'child',
                        },
                        {
                            name: me.$i18n.t('PARENTS'),
                            url: '/admin/children/parents',
                            visible:
                !!(me.globals.acl.Parents && me.globals.acl.Parents.insertAction),
                            icon: 'user-friends',
                        },
                        {
                            name: me.$i18n.t('WAITINGLIST'),
                            url: '/admin/childkindergarten/waitinglist',
                            visible:
                !!(me.globals.acl.WaitingList && me.globals.acl.WaitingList.insertAction),
                            icon: 'calendar-alt',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('CHILDKINDERGARTEN'),
                    icon: 'users',
                    visible: !!(me.globals.acl.ChildKindergarten && me.globals.acl.ChildKindergarten.insertAction),
                    children: [
                        {
                            name: me.$i18n.t('CHILDKINDERGARTEN'),
                            url: '/admin/childkindergarten/child',
                            visible:
                !!(me.globals.acl.ChildKindergarten && me.globals.acl.ChildKindergarten.insertAction),
                            icon: 'child',
                        },
                        {
                            name: me.$i18n.t('PARENTS'),
                            url: '/admin/childkindergarten/parents',
                            visible:
                !!(me.globals.acl.Parents && me.globals.acl.Parents.insertAction),
                            icon: 'user-friends',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('STRUKTUR'),
                    icon: 'syringe',
                    visible:
            !!(me.globals.acl.EducationalGroup
            && me.globals.acl.EducationalGroup.insertAction),
                    children: [
                        {
                            name: me.$i18n.t('EDUCATOR'),
                            url: '/admin/struktur/educator',
                            visible:
                !!(me.globals.acl.Educator
                && me.globals.acl.Educator.insertAction),
                            icon: 'pills',
                        },
                        {
                            name: me.$i18n.t('EDUCATIONALGROUP'),
                            url: '/admin/struktur/educationalgroup',
                            visible:
                !!(me.globals.acl.EducationalGroup
                && me.globals.acl.EducationalGroup.insertAction),
                            icon: 'pills',
                        },
                        {
                            name: me.$i18n.t('OBJECTNAME'),
                            url: '/admin/struktur/objectname',
                            visible:
                !!(me.globals.acl.ObjectName
                && me.globals.acl.ObjectName.insertAction),
                            icon: 'pills',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('THERAPY'),
                    icon: 'syringe',
                    visible:
            !!(me.globals.acl.TherapyType
            && me.globals.acl.TherapyType.insertAction),
                    children: [
                        {
                            name: me.$i18n.t('THERAPYTYPE'),
                            url: '/admin/therapy/therapytype',
                            visible:
                !!(me.globals.acl.TherapyType
                && me.globals.acl.TherapyType.insertAction),
                            icon: 'pills',
                        },
                        {
                            name: me.$i18n.t('WORKTYPE'),
                            url: '/admin/therapy/worktype',
                            visible:
                !!(me.globals.acl.WorkType
                && me.globals.acl.WorkType.insertAction),
                            icon: 'network-wired',
                        },
                        {
                            name: me.$i18n.t('DIAGNOSE'),
                            url: '/admin/therapy/diagnose',
                            visible:
                !!(me.globals.acl.Diagnose
                && me.globals.acl.Diagnose.insertAction),
                            icon: 'network-wired',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('ROOM'),
                    url: '/admin/room',
                    visible: !!(me.globals.acl.Room && me.globals.acl.Room.instantiate),
                    icon: 'building',
                },
                {
                    name: me.$i18n.t('STATISTICS'),
                    url: '/admin/statistics',
                    visible: !!(me.globals.acl.Statistics && me.globals.acl.Statistics.instantiate),
                    icon: 'chart',
                },
                {
                    name: me.$i18n.t('NOTE'),
                    url: '/admin/note',
                    visible: !!(me.globals.acl.Note && me.globals.acl.Note.instantiate),
                    icon: 'building',
                },
                {
                    name: me.$i18n.t('FINANCIAL'),
                    icon: 'money-bill-wave',
                    visible: !!(me.globals.acl.FakturkoInvoices && me.globals.acl.FakturkoInvoices.instantiate)
                        || !!(me.globals.acl.Fakturko && me.globals.acl.Fakturko.instantiate)
                        || !!(me.globals.acl.FakturkoUsers && me.globals.acl.FakturkoUsers.instantiate),
                    children: [
                        {
                            name: me.$i18n.t('FAKTURKO_INVOICES'),
                            url: '/admin/financial/invoices',
                            visible: !!(me.globals.acl.FakturkoInvoices && me.globals.acl.FakturkoInvoices.instantiate),
                            icon: 'file-invoice-dollar',
                        },
                        {
                            name: me.$i18n.t('FAKTURKO_ANALYSIS'),
                            url: '/admin/financial/analysis',
                            visible: !!(me.globals.acl.FakturkoInvoices && me.globals.acl.FakturkoInvoices.instantiate),
                            icon: 'chart-bar',
                        },
                        {
                            name: me.$i18n.t('FAKTURKO'),
                            url: '/admin/financial/logs',
                            visible: !!(me.globals.acl.Fakturko && me.globals.acl.Fakturko.instantiate),
                            icon: 'list-alt',
                        },
                        {
                            name: me.$i18n.t('FAKTURKO_USERS'),
                            url: '/admin/financial/fakturko-users',
                            visible: !!(me.globals.acl.FakturkoUsers && me.globals.acl.FakturkoUsers.instantiate),
                            icon: 'user-lock',
                        },
                    ],
                },
                {
                    name: me.$i18n.t('NOTIFICATIONS'),
                    url: '/private_notifications',
                    visible: !!(me.globals.acl.PrivateNotifications
                        && me.globals.acl.PrivateNotifications.deleteAction
                        && me.globals.companyId != null
                        && me.globals.companyId === 2),
                    icon: 'bell',
                },
                {
                    name: me.$i18n.t('SYSTEM'),
                    icon: 'cog',
                    visible: !!(me.globals.acl.Users && me.globals.acl.Users.deleteAction),
                    children: [
                        {
                            name: me.$i18n.t('ACL'),
                            url: '/admin/system/acl',
                            visible:
                !!(me.globals.acl.AclPrivilages
                && me.globals.acl.AclPrivilages.insertRow.insertAction),
                            icon: 'lock',
                        },
                        {
                            name: me.$i18n.t('TRANSLATOR'),
                            url: '/admin/system/translator',
                            visible:
                !!(me.globals.acl.Translator
                && me.globals.acl.Translator.deleteAction),
                            icon: 'flag',
                        },
                        {
                            name: me.$i18n.t('LANGUAGES'),
                            url: '/admin/system/languages',
                            visible:
                !!(me.globals.acl.TransLang && me.globals.acl.TransLang.deleteAction),
                            icon: 'globe',
                        },
                        {
                            name: me.$i18n.t('SITEPROPS'),
                            url: '/admin/system/siteprops',
                            visible:
                !!(me.globals.acl.SiteProps && me.globals.acl.SiteProps.insertAction),
                            icon: 'wrench',
                        },
                        {
                            name: me.$i18n.t('EMAILTEMPLATES'),
                            url: '/admin/system/emailtemplates',
                            visible:
                !!(me.globals.acl.EmailTemplates
                && me.globals.acl.EmailTemplates.insertAction),
                            icon: 'envelope',
                        },
                        {
                            name: me.$i18n.t('USERCOMPANIES'),
                            url: '/admin/system/usercompanies',
                            visible:
                !!(me.globals.acl.UserCompanies
                && me.globals.acl.UserCompanies.insertAction),
                            icon: 'building',
                        },
                        {
                            name: me.$i18n.t('COMPANYTYPE'),
                            url: '/admin/system/companytype',
                            visible:
                !!(me.globals.acl.CompanyType
                && me.globals.acl.CompanyType.insertAction),
                            icon: 'building',
                        },
                        {
                            name: me.$i18n.t('USERS'),
                            url: '/admin/system/users',
                            visible:
                !!(me.globals.acl.Users && me.globals.acl.Users.deleteAction),
                            icon: 'user',
                        },
                    ],
                },
            ];
        },
    },
    watch: {
        translation()
        {
            this.initMenu();
        },
        langInitialized()
        {
            this.initMenu();
        },
    },
    computed: {
        ...mapGetters(['globals', 'langInitialized', 'translation']),
        name()
        {
            return this.$route.name;
        },
        list()
        {
            return this.$route.matched;
        },
    },
};
</script>
